import { Dispatch, SetStateAction } from "react";
import { 
    DiscountFormStateType, 
    DiscountFormErrorState, 
    GenerationType, 
    ApplicationStageType, 
    JourneyStepType, 
    PaymentModeConcessionConfigType} from "src/lib/types/discounts";
import { alertSeverites } from "../constants";
import { 
    isUndefinedOrNull,
    isUndefinedOrNullOrNaNOrEmpty, 
    isValidDate, 
    isValidEndDate } from "../helpers";

export const errorMappings = {
    "DC_FORM_001": "Please enter a title",
    "DC_FORM_002": "Please enter the code",
    // "DC_FORM_003": "Please remove spaces in the code",
    "DC_FORM_004": "Please enter the number of codes to generate",                            
    "DC_FORM_005": "Please enter the code length",     
    "DC_FORM_006": "Please enter the offer value",
    // "DC_FORM_007": "Please enter the offer limit",
    "DC_FORM_008": "Please enter the quantity",
    "DC_FORM_009": "Please select atleast 1 item",
    "DC_FORM_012": "Please enter the minimum value",
    // "DC_FORM_013": "Minimum required quantity should greater than bundle size",
    // "DC_FORM_014": "Please enter the maximum value",
    "DC_FORM_015": "Maximum value should be greater than minimum value",
    // "DC_FORM_016": "Please select atleast 1 item",
    "DC_FORM_017": "Please enter a valid date and time",
    "DC_FORM_018": "Please enter a valid date and time",
    "DC_FORM_019": "Discounts cannot time travel",
    "DC_FORM_020": "Please set the offer timeout",
    // "DC_FORM_021": "Please set maximum discount uses",
    "DC_FORM_022": "Pleae enter minimum order count",
    "DC_FORM_023": "Please enter maximum order count",
    "DC_FORM_024": "Please enter a valid email",
    "DC_FORM_025": "Percentage cannot be more than 100",
    "DC_FORM_026": "Please select atleast 1 payment method. Only checked payment methods will be shown on checkout in case of manual coupon application",
    "DC_FORM_027": "Please upload a csv file with the correct format."
}


const setErrorMessage = (
  errorCodeValue: string, 
  errorKey: string, 
  errorObject: { status: boolean }, 
  setFormErrors: Dispatch<SetStateAction<DiscountFormErrorState>>,
  handleAlerts: (severity: string, message?: string) => void) => {
  const errorState = { status: true, errorCode: errorCodeValue }

  const setFormErrorState = (errorObj: any) => {
    setFormErrors((oldValues: DiscountFormErrorState) => ({ ...oldValues, ...errorObj }));
  }

  switch(errorKey) {
    //identifier
    case "identifier": 
        setFormErrorState({ identifier: errorState });
        break;

    //bulk generation inputs
    case "codeCount":
        setFormErrorState({ codeCount: errorState });
        break;
    case "codeLength":
        setFormErrorState({ codeLength: errorState });
        break;
    case "codeCSV":
        setFormErrorState({ codeCSV: errorState });
        break;
    // offer inputs
    case "offerValue":
        setFormErrorState({ offerValue: errorState });
        break;
    case "offerLimit":
        setFormErrorState({ offerLimit: errorState });
        break;
    case "entitledQuantity":
        setFormErrorState({ entitledQuantity: errorState });
        break;

    //threshold inputs
    case "minRequirement":
        setFormErrorState({ minRequirement: errorState });
        break;
    case "maxRequirement":
        setFormErrorState({ maxRequirement: errorState });
        break;

    //customer eligibility inputs
    case "minOrderCount":
        setFormErrorState({ minOrderCount: errorState });
        break;
    case "maxOrderCount":
        setFormErrorState({ maxOrderCount: errorState });
        break;

    //usage limit inputs
    case "maxUses":
        setFormErrorState({ maxUses: errorState });
        break;
    case "customerCSV":
        setFormErrorState({ customerCSV: errorState });
        break;

    //Catalogue selections
    case "prerequisteProducts":
        setFormErrorState({ prerequisteProducts: errorState });
        break;
    case "entitledProducts":
        setFormErrorState({ entitledProducts: errorState });
        break;
    case "coveredProducts":
        setFormErrorState({ coveredProducts: errorState });
        break;

    //Active period inputs
    case "endDate":
        setFormErrorState({ endDate: errorState });
        break;
    case "startDate":
        setFormErrorState({ startDate: errorState });
        break;
    case "activePeriod":
        setFormErrorState({ activePeriod: errorState });
        break;
    case "paymentModeChecklist": 
        setFormErrorState({ paymentModeChecklist: errorState });
        break;
    }
    
    
    // handleAlerts(
    //     alertSeverites.SEVERITY_ERROR, 
    //     "Some inputs might be filled incorrect!"
    // );
    errorObject.status = true;
}

export const isInvalidForm = (
  discountFormState: DiscountFormStateType | undefined, 
  setFormErrors: Dispatch<SetStateAction<DiscountFormErrorState>>,
  handleAlerts: (severity: string, message?: string) => void,
  isEditMode: boolean,
  generationType: GenerationType | undefined,
  applicationStage: ApplicationStageType | undefined,
//   currentStep: JourneyStepType
  ) => {
    
    const {
        setup,
        conditions,
        customerEligibility,
        usageLimits
    } = discountFormState || {};

    const { applicationMethodConfig, applicationConfig } = setup || {};

    const {
        coverageConfig,
        offerValueConfig,
        entitlementsConfig,
        discountGenerationConfig
    } = applicationConfig || {};

    const { thresholdConfig, prerequisitesConfig } = conditions || {};

    const {
        discountUsesConfig,
        activePeriodConfig
    } = usageLimits || {};



  
    const errorFound = { status: false };


    //Input Field: Indentifier
    if (applicationStage === "CART_DISCOVERY" || applicationStage === "PRE_PAYMENT_VALIDATION") {
        if (generationType === "SINGLE") {
            if (applicationMethodConfig?.valueType === "AUTOMATIC") {
                (!Boolean(applicationMethodConfig?.value?.trim()?.length)) && 
                    setErrorMessage("DC_FORM_001", "identifier", errorFound, setFormErrors, handleAlerts);
            } else {
                if(!Boolean(applicationMethodConfig?.value?.trim()?.length)) {
                    setErrorMessage("DC_FORM_002", "identifier", errorFound, setFormErrors, handleAlerts);
                }
                // else { 
                //     !Boolean(applicationMethodConfig?.value?.match(/\s/)) &&
                //     setErrorMessage("DC_FORM_003", "identifier", errorFound, setFormErrors, handleAlerts);
                // }
            }
        } else {
            (!Boolean(applicationMethodConfig?.value?.trim()?.length)) && 
                setErrorMessage("DC_FORM_001", "identifier", errorFound, setFormErrors, handleAlerts);
        }
    }

    //Input Field: Code count
    if (applicationStage === "CART_DISCOVERY" && generationType === "BULK" && 
        discountGenerationConfig?.bulkGenerationConfig?.valueType === "RANDOM_CODES" && 
        isUndefinedOrNullOrNaNOrEmpty(discountGenerationConfig?.bulkGenerationConfig?.codeCount)) {
        setErrorMessage("DC_FORM_004", "codeCount", errorFound, setFormErrors, handleAlerts); 
    }

    //Input Field: Code length
    if (applicationStage === "CART_DISCOVERY" && generationType === "BULK" && 
        discountGenerationConfig?.bulkGenerationConfig?.valueType === "RANDOM_CODES" &&
        isUndefinedOrNullOrNaNOrEmpty(discountGenerationConfig?.bulkGenerationConfig?.codeLength)) {
        setErrorMessage("DC_FORM_005", "codeLength", errorFound, setFormErrors, handleAlerts);
    }

    //File upload: Bulk discount
    if (applicationStage === "CART_DISCOVERY" && generationType === "BULK" && 
        discountGenerationConfig?.bulkGenerationConfig?.valueType === "CSV_UPLOAD" && !isEditMode &&
        isUndefinedOrNull(discountGenerationConfig?.bulkGenerationConfig?.uploadedFilePath)) {
        setErrorMessage("DC_FORM_027", "codeCSV", errorFound, setFormErrors, handleAlerts);
    }

    //File upload: Customer context
    if ((applicationStage === "CART_DISCOVERY" || applicationStage === "PRE_PAYMENT_VALIDATION") && !isEditMode &&
        customerEligibility?.valueType === "SPECIFIC" && isUndefinedOrNull(customerEligibility?.uploadedFilePath)) {
        setErrorMessage("DC_FORM_027", "customerCSV", errorFound, setFormErrors, handleAlerts);
    }

    //Input Field: Offer value
    if (!Boolean(applicationStage === "PRE_PAYMENT_VALIDATION" && offerValueConfig?.paymentModeCoverageType === "SPECIFIC") && 
        isUndefinedOrNullOrNaNOrEmpty(offerValueConfig?.value)) {
        setErrorMessage("DC_FORM_006", "offerValue", errorFound, setFormErrors, handleAlerts);
    } else if (offerValueConfig?.valueType === "PERCENTAGE") {
        parseFloat(offerValueConfig.value.toString()) > 100 &&  setErrorMessage("DC_FORM_025", "offerValue", errorFound, setFormErrors, handleAlerts);
    } 

    //Input Field: Offer limit
    // if (Boolean(offerValueConfig?.capCheckboxConfig?.valueType) && 
    //     isUndefinedOrNullOrNaNOrEmpty(offerValueConfig?.cappedValue)) {
    //     setErrorMessage("DC_FORM_007", "offerLimit", errorFound, setFormErrors, handleAlerts);
    // }

    //Input Field: Entitled quantity 
    if (applicationStage === "CART_DISCOVERY" && applicationConfig?.valueType !== "AMOUNT" && 
        isUndefinedOrNullOrNaNOrEmpty(offerValueConfig?.quantity)) {
        setErrorMessage("DC_FORM_008", "entitledQuantity", errorFound, setFormErrors, handleAlerts);
    }

    //Catalogue Search: Entitled/Covered products    
    if (applicationStage === "CART_DISCOVERY") {
        switch (applicationConfig?.valueType) {
            case "AMOUNT":
                (Boolean(coverageConfig?.valueType !== "ALL") && 
                    !Boolean(coverageConfig?.coveredItemsConfig?.items?.length || 
                    coverageConfig?.coveredItemsConfig?.variants?.length)) &&
                    setErrorMessage("DC_FORM_009", "coveredProducts", errorFound, setFormErrors, handleAlerts); 
                break;
            case "BXGY":
                (!Boolean(entitlementsConfig?.entitledItemsConfig?.variants?.length)) &&
                    setErrorMessage("DC_FORM_009", "entitledProducts", errorFound, setFormErrors, handleAlerts); 
                break;
            case "BUNDLE":
                (Boolean(entitlementsConfig?.valueType !== "ALL") &&        
                    !Boolean(entitlementsConfig?.entitledItemsConfig?.variants?.length || 
                    entitlementsConfig?.entitledItemsConfig?.items?.length)) &&
                    setErrorMessage("DC_FORM_009", "entitledProducts", errorFound, setFormErrors, handleAlerts); 
                break;
        }
    }
  
    //Input Field: Minimum threshold
    if ((applicationStage === "CART_DISCOVERY" || applicationStage === "PRE_PAYMENT_VALIDATION") && thresholdConfig?.valueType !== "NONE") {
        if (applicationConfig?.valueType !== "BUNDLE") {
            isUndefinedOrNullOrNaNOrEmpty(thresholdConfig?.minValue) &&
            setErrorMessage("DC_FORM_012", "minRequirement", errorFound, setFormErrors, handleAlerts);
        } 
            // else {
            //     (applicationConfig?.valueType === "BUNDLE") &&
            //     thresholdConfig?.minValue && offerValueConfig?.quantity && 
            //     Boolean(thresholdConfig?.minValue < offerValueConfig?.quantity) && 
            //     setErrorMessage("DC_FORM_013", "minRequirement", errorFound, setFormErrors, handleAlerts);
            // }
    }
   
    //Input Field: Maximum threshold
    if ((applicationStage === "CART_DISCOVERY" || applicationStage === "PRE_PAYMENT_VALIDATION") && thresholdConfig?.valueType !== "NONE" && 
        Boolean(thresholdConfig?.maxCheckboxConfig?.valueType)) {
        // if (isUndefinedOrNullOrNaNOrEmpty(thresholdConfig?.maxValue)) {
        //     setErrorMessage("DC_FORM_014", "maxRequirement", errorFound, setFormErrors, handleAlerts);
        // } 
        if (thresholdConfig?.maxValue && thresholdConfig?.minValue && 
            parseFloat(thresholdConfig.maxValue.toString()) < parseFloat(thresholdConfig.minValue.toString())) {
            setErrorMessage("DC_FORM_015", "maxRequirement", errorFound, setFormErrors, handleAlerts);
        }
    }

    //Catalogue Search: Prerequisite products
    if ((applicationStage === "CART_DISCOVERY" || applicationStage === "PRE_PAYMENT_VALIDATION") && prerequisitesConfig?.valueType !== "ALL") {
        !Boolean(prerequisitesConfig?.prerequisiteItemsConfig?.items?.length || 
            prerequisitesConfig?.prerequisiteItemsConfig?.variants?.length) &&
            setErrorMessage("DC_FORM_009", "prerequisteProducts", errorFound, setFormErrors, handleAlerts);
    }

    //Input Field: Start date
    if ((applicationStage === "CART_DISCOVERY" || applicationStage === "PRE_PAYMENT_VALIDATION") && !isValidDate(activePeriodConfig?.startDate)) {
        setErrorMessage("DC_FORM_017", "startDate", errorFound, setFormErrors, handleAlerts);
    }
    
    //Input Field: End date
    if ((applicationStage === "CART_DISCOVERY" || applicationStage === "PRE_PAYMENT_VALIDATION") && Boolean(activePeriodConfig?.endDataCheckboxConfig?.valueType)) {
        if(!isValidDate(activePeriodConfig?.endDate)) {
            setErrorMessage("DC_FORM_018", "endDate", errorFound, setFormErrors, handleAlerts);
        } else {
            // Validation for end date > start date
            !isValidEndDate(activePeriodConfig?.endDate, activePeriodConfig?.startDate) &&
            setErrorMessage("DC_FORM_019", "endDate", errorFound, setFormErrors, handleAlerts);
        }
    }

    //Input Field: Active period
    if (applicationStage === "POST_ORDER_PLACEMENT" && isUndefinedOrNullOrNaNOrEmpty(activePeriodConfig?.activePeriod)) {
        setErrorMessage("DC_FORM_020", "activePeriod", errorFound, setFormErrors, handleAlerts); 
    }

    //Input Field: Max uses
    if (applicationStage === "CART_DISCOVERY" && generationType !== "BULK" && Boolean(discountUsesConfig?.maxUsesCheckboxConfig?.valueType) && 
        isUndefinedOrNullOrNaNOrEmpty(discountUsesConfig?.maxUses)) {
        setErrorMessage("DC_FORM_021", "maxUses", errorFound, setFormErrors, handleAlerts);
    }

    //Input Field: Minimum order count 
    if ((applicationStage === "CART_DISCOVERY" || applicationStage === "PRE_PAYMENT_VALIDATION") && customerEligibility?.valueType === "CONDITIONAL" && 
        isUndefinedOrNullOrNaNOrEmpty(customerEligibility?.minOrderCount)) {
        setErrorMessage("DC_FORM_022", "minOrderCount", errorFound, setFormErrors, handleAlerts);
    }

    // Input Field: Maximum order count 
    // if ((applicationStage === "CART_DISCOVERY" || applicationStage === "PRE_PAYMENT_VALIDATION") && customerEligibility?.valueType === "CONDITIONAL" &&
    //     Boolean(customerEligibility?.maxOrderCountCheckboxConfig?.valueType) && 
    //     isUndefinedOrNullOrNaNOrEmpty(customerEligibility?.maxOrderCount)) {
    //     setErrorMessage("DC_FORM_023", "maxOrderCount", errorFound, setFormErrors, handleAlerts);
    // }

    if ((applicationStage === "CART_DISCOVERY" || applicationStage === "PRE_PAYMENT_VALIDATION") && customerEligibility?.valueType === "CONDITIONAL" && 
        Boolean(customerEligibility?.maxOrderCountCheckboxConfig?.valueType) &&
        customerEligibility?.maxOrderCount && customerEligibility.minOrderCount && 
        parseFloat(customerEligibility.maxOrderCount.toString()) < parseFloat(customerEligibility?.minOrderCount.toString())) {
        setErrorMessage("DC_FORM_015", "maxOrderCount", errorFound, setFormErrors, handleAlerts);
    }
   
    if (applicationStage === "PRE_PAYMENT_VALIDATION" && 
        offerValueConfig?.paymentModeCoverageType === "SPECIFIC" && 
        applicationMethodConfig?.valueType === "MANUAL") {
            let methodCount = 0;
            offerValueConfig?.paymentModeConcessions?.forEach((mode: PaymentModeConcessionConfigType) => 
                methodCount += Boolean(mode?.paymentModeCheckboxConfig?.valueType) ? 1 : 0);
            if (!Boolean(methodCount)) setErrorMessage("DC_FORM_026", "paymentModeChecklist", errorFound, setFormErrors, handleAlerts);
        }
    return errorFound.status;
}
